import { inject, observer } from 'mobx-react';
import * as React from 'react';

const customerIdAsKey = (WrappedComponent: (props: any) => JSX.Element): any => {
  const component = (props: any) => {
    return (
      <WrappedComponent {...props} key={props.ssoStore.customerId}>
        {props.children}
      </WrappedComponent>
    );
  };
  return inject('ssoStore')(observer(component));
};

export default customerIdAsKey;
